const ACTIONS_MENU_MODAL_LAYER_CLASS = 'actions-menu__modal-layer';

export class NavModalLayer extends HTMLElement {

  connectedCallback(): void {
    this.addEventListener('click', () => {
      this.hide();
    });
  }

  show(): void {
    this.classList.add(ACTIONS_MENU_MODAL_LAYER_CLASS);
    this.emit('update', true);
  }

  hide(): void {
    this.classList.remove(ACTIONS_MENU_MODAL_LAYER_CLASS);
    this.emit('update', false);
  }

  get isVisible(): boolean {
    return this.classList.contains(ACTIONS_MENU_MODAL_LAYER_CLASS);
  }

  // TODO: emitter as mixin?
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  emit(name: string, data?: any): void {
    this.dispatchEvent(new CustomEvent(name, { detail: data }))
  }

}

let modalLayer: NavModalLayer;

export function getModalLayer(): NavModalLayer {
  if (modalLayer) {
    return modalLayer;
  }

  let el: NavModalLayer;
  const elements = document.getElementsByTagName('nav-modal-layer');
  if (elements && elements[0]) {
    el = elements[0] as NavModalLayer;
  }
  if (!el) {
    el = document.createElement('nav-modal-layer') as NavModalLayer;
    el.classList.add('modal-layer');
    document.body.appendChild(el);
  }
  modalLayer = el as NavModalLayer;

  return modalLayer;
}

window.customElements.define('nav-modal-layer', NavModalLayer);
